// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Spinloader from "./Spinloader";
// import { useUserType } from '../../routes/common/UserTypeContext';
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { Icon } from 'react-icons-kit';
// import { eyeOff } from 'react-icons-kit/feather/eyeOff';
// import { eye } from 'react-icons-kit/feather/eye'
// // My css
// import css from "../../css/common/login-form.module.css";
// // ! Disable login button when loading by creating isLoading state, so user cannot press it again and again

// import { validation } from "../../utilities/constants";
// import { capitalizeFirstLetter } from "../../utilities/helper_functions";

// export const LoginForm = (props) => {
//   const [modal, setModalOpen] = useState(false);
//   const [loader, setLoader] = useState(false);
//   const [emailSuccess, setEmailSuccess] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [recoveryEmail, setRecoveryEmail] = useState(""); // New state for recovery email
//   const [newPassword, setNewPassword] = useState(""); // New state for password reset
//   const [confirmPassword, setConfirmPassword] = useState(""); // New state for password confirmation
//   const [passwordResetSuccess, setPasswordResetSuccess] = useState(false); // New state for password reset success
//   const { userType } = useUserType();
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [type, setType] = useState('password');
//   const [icon, setIcon] = useState(eyeOff);

//   // Reset modal state when userType changes while modal is open
//   useEffect(() => {
//     if (modal) {
//       setEmailSuccess(false);
//       setPasswordResetSuccess(false);
//       setRecoveryEmail("");
//       setNewPassword("");
//       setConfirmPassword("");
//       setIsLoading(false);
//     }
//   }, [userType, modal]);

//   const handleChange = (e) => {
//     props.onChange(e); // Need to pass the whole event, passing updatedField just gives the last entered character of the input
//   };

//   const handleLogInClick = () => {
//     props.onClick();
//   };

//   function handleForgotPassClick() {
//     setTimeout(() => {
//       setModalOpen(true);
//     }, 1000);
//     setLoader(true);
//     setTimeout(() => {
//       setLoader(false);
//     }, 1000);
//   }
//   const handleToggle = () => {
//     if (type === 'password') {
//       setIcon(eye);
//       setType('text')
//     } else {
//       setIcon(eyeOff)
//       setType('password')
//     }
//   }
//   function handleModalClose() {
//     setModalOpen(false);
//     setEmailSuccess(false);
//     setPasswordResetSuccess(false);
//     setRecoveryEmail(""); // Reset recovery email when modal is closed
//     setNewPassword(""); // Reset new password when modal is closed
//     setConfirmPassword(""); // Reset confirm password when modal is closed
//   }

//   // async function handleSubmitClick() {
//   //   setIsLoading(true);

//   //   try {
//   //     // For region EM users, use the direct password reset
//   //     if (userType === 'regionem') {
//   //       if (!newPassword || !confirmPassword) {
//   //         toast.error("Please fill in both password fields");
//   //         setIsLoading(false);
//   //         return;
//   //       }

//   //       if (newPassword !== confirmPassword) {
//   //         toast.error("Passwords do not match");
//   //         setIsLoading(false);
//   //         return;
//   //       }

//   //       const response = await fetch(
//   //         `${SERVER_ORIGIN}/api/${userType}/auth/recover-pwd`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify({
//   //             email: recoveryEmail,
//   //             newPassword: newPassword,
//   //             confirmPassword: confirmPassword
//   //           }),
//   //         }
//   //       );

//   //       setIsLoading(false);
//   //       const result = await response.json();

//   //       if (response.status >= 400 && response.status < 600) {
//   //         toast.error(result.statusText);
//   //       } else if (response.ok && response.status === 200) {
//   //         setPasswordResetSuccess(true);
//   //         toast.success(result.statusText);

//   //         // Redirect to Region EM login page after 2 seconds
//   //         setTimeout(() => {
//   //           handleModalClose();                       // <-- closes modal & resets flags
//   //           navigate('/login?userType=regionem', { replace: true });
//   //         }, 500);
//   //       } else {
//   //         toast.error("An error occurred. Please try again.");
//   //       }
//   //     } else {
//   //       // For other user types, use the existing email-based recovery
//   //       const response = await fetch(
//   //         `${SERVER_ORIGIN}/api/${userType}/auth/recover-pwd`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify({ email: recoveryEmail }),
//   //         }
//   //       );

//   //       setIsLoading(false);
//   //       const result = await response.json();

//   //       if (response.status >= 400 && response.status < 600) {
//   //         if (response.status === 401) {
//   //           toast.error(result.statusText);
//   //         } else {
//   //           toast.error(result.statusText);
//   //         }
//   //       } else if (response.ok && response.status === 200) {
//   //         setEmailSuccess(true);
//   //       } else {
//   //         // for future
//   //       }
//   //     }
//   //   } catch (error) {
//   //     setIsLoading(false);
//   //     toast.error("An error occurred. Please try again.");
//   //   }
//   // }
//   async function handleSubmitClick() {
//     setIsLoading(true);

//     try {
//       // For region EM users, use the direct password reset
//       if (userType === 'regionem') {
//         if (!newPassword || !confirmPassword) {
//           toast.error("Please fill in both password fields");
//           setIsLoading(false);
//           return;
//         }

//         if (newPassword !== confirmPassword) {
//           toast.error("Passwords do not match");
//           setIsLoading(false);
//           return;
//         }

//         const response = await fetch(
//           `${SERVER_ORIGIN}/api/${userType}/auth/recover-pwd`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               email: recoveryEmail,
//               newPassword,
//               confirmPassword
//             }),
//           }
//         );

//         setIsLoading(false);
//         const result = await response.json();

//         if (!response.ok) {
//           toast.error(result.statusText || "Something went wrong");
//           return;
//         }

//         setPasswordResetSuccess(true);
//         toast.success(result.statusText || "Password reset successfully!");

//         // ✅ Detect current login page
//         const currentPath = window.location.pathname;
//         let redirectPath = "/login";

//         if (currentPath.includes("yuva-login")) {
//           redirectPath = "/yuva-login";
//         } else if (currentPath.includes("thalir-login")) {
//           redirectPath = "/thalir-login";
//         }

//         // ✅ Redirect correctly after short delay
//         setTimeout(() => {
//           handleModalClose();
//           navigate(`${redirectPath}?userType=regionem`, { replace: true });
//         }, 800);
//       } else {
//         // For other user types (email-based recovery)
//         const response = await fetch(
//           `${SERVER_ORIGIN}/api/${userType}/auth/recover-pwd`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ email: recoveryEmail }),
//           }
//         );

//         setIsLoading(false);
//         const result = await response.json();

//         if (!response.ok) {
//           toast.error(result.statusText || "Error sending recovery mail");
//           return;
//         }

//         setEmailSuccess(true);
//         toast.success("Recovery mail sent successfully!");
//       }
//     } catch (error) {
//       setIsLoading(false);
//       toast.error("An error occurred. Please try again.");
//     }
//   }


//   return (
//     // <div className="loginWrapper">
//     //   <div className={css.outerDiv} style={props.compact ? { width: '100%', maxWidth: '440px', margin: '0 auto' } : undefined}>
//     //     {modal ? (
//     //       <div className={css.loginModal}>
//     //         <p className={css.passHeading}>
//     //           {userType === "regionem"
//     //             ? "Reset Password"
//     //             : "Recover Password"}
//     //         </p>
//     //         <div
//     //           style={{
//     //             display: "flex",
//     //             flexDirection: "column",
//     //             gap: "1rem",
//     //           }}
//     //         >
//     //           <input
//     //             type="email"
//     //             id="newPassEmail"
//     //             placeholder="Enter your email"
//     //             autoComplete="on"
//     //             className={css.forgotPassInput}
//     //             value={recoveryEmail}
//     //             onChange={(e) => setRecoveryEmail(e.target.value)}
//     //           />

//     //           {userType === "regionem" && (
//     //             <>
//     //               <input
//     //                 type="password"
//     //                 id="newPassword"
//     //                 placeholder="New Password"
//     //                 autoComplete="new-password"
//     //                 className={css.forgotPassInput}
//     //                 value={newPassword}
//     //                 onChange={(e) => setNewPassword(e.target.value)}
//     //               />
//     //               <input
//     //                 type="password"
//     //                 id="confirmPassword"
//     //                 placeholder="Confirm New Password"
//     //                 autoComplete="new-password"
//     //                 className={css.forgotPassInput}
//     //                 value={confirmPassword}
//     //                 onChange={(e) => setConfirmPassword(e.target.value)}
//     //               />

//     //               {/* Password validation instructions */}
//     //               <div
//     //                 style={{
//     //                   border: "2px dashed #cccccc",
//     //                   padding: "0.8rem",
//     //                   margin: "0.5rem 0",
//     //                   backgroundColor: "#f5f5f5",
//     //                   borderRadius: "4px",
//     //                   fontSize: "0.85rem",
//     //                   textAlign: "left",
//     //                 }}
//     //               >
//     //                 <p style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
//     //                   Make sure the password contains:
//     //                 </p>
//     //                 <ul style={{ margin: "0", paddingLeft: "1.2rem" }}>
//     //                   <li>Minimum 8 characters</li>
//     //                   <li>At least one uppercase letter</li>
//     //                   <li>At least one lowercase letter</li>
//     //                   <li>At least one number</li>
//     //                   <li>At least one special character</li>
//     //                 </ul>
//     //               </div>
//     //             </>
//     //           )}
//     //         </div>

//     //         {emailSuccess && userType !== "regionem" && (
//     //           <p className={css.EmailSuccessText}>
//     //             A mail has been sent to your e-mail address.
//     //           </p>
//     //         )}

//     //         {passwordResetSuccess && userType === "regionem" && (
//     //           <p className={css.EmailSuccessText}>
//     //             Password reset successfully! Redirecting to login page...
//     //           </p>
//     //         )}

//     //         <div className={css.forgotPassBtnWrapper}>
//     //           <button
//     //             className={css.forgotPassCancelBtn}
//     //             onClick={handleModalClose}
//     //           >
//     //             Cancel
//     //           </button>
//     //           {!emailSuccess && !passwordResetSuccess && (
//     //             <button
//     //               className={css.forgotPassBtn}
//     //               onClick={handleSubmitClick}
//     //               disabled={isLoading}
//     //             >
//     //               {isLoading
//     //                 ? "Processing..."
//     //                 : userType === "regionem"
//     //                   ? "Reset Password"
//     //                   : "Submit"}
//     //             </button>
//     //           )}
//     //         </div>
//     //       </div>
//     //     ) : (
//     //       <div>
//     //         {/* <p className={css.heading}>
//     //                         {props.role === 'regionem'
//     //                             ? 'Region EM'
//     //                             : capitalizeFirstLetter(props.role)}{" "}Login
//     //                     </p> */}
//     //         {/* <p className={css.heading}>
//     //             {props.role === "regionem"
//     //               ? "Regional Mentor"
//     //               : props.role === "em"
//     //               ? "Chapter EM"
//     //               :props.role ==="institute"
//     //               ? "YUVA/Thalir"
//     //               : capitalizeFirstLetter(props.role)}{" "}
//     //             Login
//     //           </p> */}

//     //         {/* <p className={css.heading}>
//     //                         {capitalizeFirstLetter(props.role)}{" "}Login
//     //                     </p> */}
//     //         <label htmlFor="email" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//     //           Email ID
//     //         </label>
//     //         {props.role === "admin" || props.role === "user" ? (

//     //           <input
//     //             className={css.input}
//     //             type="text"
//     //             placeholder={
//     //               props.role === "user"
//     //                 ? "Enter Student Username or Email"
//     //                 : "Enter Admin ID"
//     //             }
//     //             name={props.role === "user" ? "userId" : "adminId"}
//     //             value={props.role === "user" ? props.userId : props.adminId}
//     //             onChange={handleChange}
//     //             maxLength={validation.authForm.userId.maxLen}
//     //             autoComplete="on"
//     //           />
//     //         ) : (
//     //           // <input
//     //           //     className={css.input}
//     //           //     type="text"
//     //           //     placeholder={
//     //           //         props.role === "institute"
//     //           //             ? "Enter Institute Email"
//     //           //             : "Enter Chapter EM Email"
//     //           //     }
//     //           //     name={props.role === "institute" ? "instituteEmail" : "email"}
//     //           //     value={
//     //           //         props.role === "institute"
//     //           //             ? props.instituteEmail
//     //           //             : props.email
//     //           //     }
//     //           //     onChange={handleChange}
//     //           //     maxLength={validation.authForm.userId.maxLen}
//     //           //     autoComplete="on"
//     //           // />
//     //           <input
//     //             className={css.input}
//     //             type="text"
//     //             placeholder={
//     //               props.role === "institute"
//     //                 ? "Enter Institute Email"
//     //                 : props.role === "regionem"
//     //                   ? "Enter Regional Mentor Email"
//     //                   : "Enter Chapter EM Email"
//     //             }
//     //             name={props.role === "institute" ? "instituteEmail" : "email"}
//     //             value={
//     //               props.role === "institute"
//     //                 ? props.instituteEmail
//     //                 : props.email
//     //             }
//     //             onChange={handleChange}
//     //             maxLength={validation.authForm.userId.maxLen}
//     //             autoComplete="on"
//     //           />
//     //         )}
//     //         <div>
//     //           <div>
//     //             <div class="mb-4 flex" style={{ position: "relative" }}>
//     //               <label htmlFor="email" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//     //                 Password
//     //               </label>
//     //               <input
//     //                 className={css.input}
//     //                 type={type}
//     //                 name="password"
//     //                 placeholder="Password"
//     //                 value={props.password}
//     //                 onChange={handleChange}
//     //                 maxLength={validation.authForm.password.maxLen}
//     //                 autoComplete="on"
//     //               />
//     //               <span
//     //                 class="flex justify-around items-center"
//     //                 onClick={handleToggle}
//     //                 style={{
//     //                   position: "absolute",
//     //                   right: "10px",
//     //                   top: "7.2px",
//     //                 }}
//     //               >
//     //                 <Icon class="absolute mr-10" icon={icon} size={25} />
//     //               </span>
//     //             </div>
//     //           </div>
//     //         </div>
//     //         <Link
//     //           onClick={handleForgotPassClick}
//     //           className={css.forgotPassText}
//     //         >
//     //           Forgot Password
//     //         </Link>
//     //         {loader && (
//     //           <div className={css.forgotPassLoaderWrapper}>
//     //             <div className={css.forgotPassLoader}>
//     //               <Spinloader />
//     //             </div>
//     //           </div>
//     //         )}
//     //         <button
//     //           className={css.btn}
//     //           onClick={handleLogInClick}
//     //           disabled={props.isBtnDisabled}
//     //         >
//     //           {props.isBtnDisabled ? "Logging in..." : "Login"}
//     //         </button>
//     //         {props.role === "user" && (
//     //           <>
//     //             <p className={css.forgotPassText}>Don't have an account ?</p>
//     //             <Link className={css.registerText} to="/user/register">
//     //               Register
//     //             </Link>
//     //           </>
//     //         )}
//     //       </div>
//     //     )}
//     //   </div>
//     // </div>

//     <div className="loginWrapper">
//       <div className={css.outerDiv} style={props.compact ? { width: '100%', maxWidth: '440px', margin: '0 auto' } : undefined}>
//         {/* {modal ? (
//           <div className={css.loginModal}>
//             <p className={css.passHeading}>
//               {userType === "regionem"
//                 ? "Reset Password"
//                 : "Recover Password"}
//             </p>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "1rem",
//               }}
//             >
//               <div>
//                 <label htmlFor="email" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//                   Email ID
//                 </label>
//                 <input
//                   type="email"
//                   id="newPassEmail"
//                   placeholder="Enter your email"
//                   autoComplete="on"
//                   className={css.forgotPassInput}
//                   value={recoveryEmail}
//                   onChange={(e) => setRecoveryEmail(e.target.value)}
//                 />
//               </div>

//               {userType === "regionem" && (
//                 <>
//                   <div>
//                     <label htmlFor="newPassword" className={css.label}>
//                       New Password
//                     </label>
//                     <input
//                       type="password"
//                       id="newPassword"
//                       placeholder="New Password"
//                       autoComplete="new-password"
//                       className={css.forgotPassInput}
//                       value={newPassword}
//                       onChange={(e) => setNewPassword(e.target.value)}
//                     />
//                   </div>
//                   <div>
//                     <label htmlFor="confirmPassword" className={css.label}>
//                       Confirm New Password
//                     </label>
//                     <input
//                       type="password"
//                       id="confirmPassword"
//                       placeholder="Confirm New Password"
//                       autoComplete="new-password"
//                       className={css.forgotPassInput}
//                       value={confirmPassword}
//                       onChange={(e) => setConfirmPassword(e.target.value)}
//                     />
//                   </div>

//         <div
//           style={{
//             border: "2px dashed #cccccc",
//             padding: "0.8rem",
//             margin: "0.5rem 0",
//             backgroundColor: "#f5f5f5",
//             borderRadius: "4px",
//             fontSize: "0.85rem",
//             textAlign: "left",
//           }}
//         >
//           <p style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
//             Make sure the password contains:
//           </p>
//           <ul style={{ margin: "0", paddingLeft: "1.2rem" }}>
//             <li>Minimum 8 characters</li>
//             <li>At least one uppercase letter</li>
//             <li>At least one lowercase letter</li>
//             <li>At least one number</li>
//             <li>At least one special character</li>
//           </ul>
//         </div>
//       </>
//               )}
//     </div>

//             {
//     emailSuccess && userType !== "regionem" && (
//       <p className={css.EmailSuccessText}>
//         A mail has been sent to your e-mail address.
//       </p>
//     )
//   }

//   {
//     passwordResetSuccess && userType === "regionem" && (
//       <p className={css.EmailSuccessText}>
//         Password reset successfully! Redirecting to login page...
//       </p>
//     )
//   }

//   <div className={css.forgotPassBtnWrapper}>
//     <button
//       className={css.forgotPassCancelBtn}
//       onClick={handleModalClose}
//     >
//       Cancel
//     </button>
//     {!emailSuccess && !passwordResetSuccess && (
//       <button
//         className={css.forgotPassBtn}
//         onClick={handleSubmitClick}
//         disabled={isLoading}
//       >
//         {isLoading
//           ? "Processing..."
//           : userType === "regionem"
//             ? "Reset Password"
//             : "Submit"}
//       </button>
//     )}
//   </div>
//           </div > */}
//         {
//           modal ? (
//             <div className={css.loginModal}>
//               <p className={css.passHeading}>
//                 {props.role === "regionem"
//                   ? "Reset Password"
//                   : "Recover Password"}
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "1rem",
//                 }}
//               >
//                 <div>
//                   <label htmlFor="email" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//                     Email ID
//                   </label>
//                   <input
//                     type="email"
//                     id="newPassEmail"
//                     placeholder="Enter your email"
//                     autoComplete="on"
//                     className={css.forgotPassInput}
//                     value={recoveryEmail}
//                     onChange={(e) => setRecoveryEmail(e.target.value)}
//                   />
//                 </div>

//                 {props.role === "regionem" && (
//                   <>
//                     <div>
//                       <label htmlFor="newPassword" className={css.label}>
//                         New Password
//                       </label>
//                       <input
//                         type="password"
//                         id="newPassword"
//                         placeholder="New Password"
//                         autoComplete="new-password"
//                         className={css.forgotPassInput}
//                         value={newPassword}
//                         onChange={(e) => setNewPassword(e.target.value)}
//                       />
//                     </div>
//                     <div>
//                       <label htmlFor="confirmPassword" className={css.label}>
//                         Confirm New Password
//                       </label>
//                       <input
//                         type="password"
//                         id="confirmPassword"
//                         placeholder="Confirm New Password"
//                         autoComplete="new-password"
//                         className={css.forgotPassInput}
//                         value={confirmPassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                       />
//                     </div>

//                     {/* Password validation instructions */}
//                     <div
//                       style={{
//                         border: "2px dashed #cccccc",
//                         padding: "0.8rem",
//                         margin: "0.5rem 0",
//                         backgroundColor: "#f5f5f5",
//                         borderRadius: "4px",
//                         fontSize: "0.85rem",
//                         textAlign: "left",
//                       }}
//                     >
//                       <p style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
//                         Make sure the password contains:
//                       </p>
//                       <ul style={{ margin: "0", paddingLeft: "1.2rem" }}>
//                         <li>Minimum 8 characters</li>
//                         <li>At least one uppercase letter</li>
//                         <li>At least one lowercase letter</li>
//                         <li>At least one number</li>
//                         <li>At least one special character</li>
//                       </ul>
//                     </div>
//                   </>
//                 )}
//               </div>

//               {emailSuccess && props.role !== "regionem" && (
//                 <p className={css.EmailSuccessText}>
//                   A mail has been sent to your e-mail address.
//                 </p>
//               )}

//               {passwordResetSuccess && props.role === "regionem" && (
//                 <p className={css.EmailSuccessText}>
//                   Password reset successfully! Redirecting to login page...
//                 </p>
//               )}

//               <div className={css.forgotPassBtnWrapper}>
//                 <button
//                   className={css.forgotPassCancelBtn}
//                   onClick={handleModalClose}
//                 >
//                   Cancel
//                 </button>
//                 {!emailSuccess && !passwordResetSuccess && (
//                   <button
//                     className={css.forgotPassBtn}
//                     onClick={handleSubmitClick}
//                     disabled={isLoading}
//                   >
//                     {isLoading
//                       ? "Processing..."
//                       : props.role === "regionem"
//                         ? "Reset Password"
//                         : "Submit"}
//                   </button>
//                 )}
//               </div>
//             </div>
//           ) : (
//             <div>
//               {props.role === "admin" || props.role === "user" ? (
//                 <div className={css.inputGroup}>
//                   <label htmlFor="userId" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//                     {props.role === "user" ? "Student Username or Email" : "Admin ID"}
//                   </label>
//                   <input
//                     id="userId"
//                     className={css.input}
//                     type="text"
//                     placeholder={
//                       props.role === "user"
//                         ? "Enter Student Username or Email"
//                         : "Enter Admin ID"
//                     }
//                     name={props.role === "user" ? "userId" : "adminId"}
//                     value={props.role === "user" ? props.userId : props.adminId}
//                     onChange={handleChange}
//                     maxLength={validation.authForm.userId.maxLen}
//                     autoComplete="on"
//                   />
//                 </div>
//               ) : (
//                 <div className={css.inputGroup}>
//                   <label htmlFor="email" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//                     Email ID
//                   </label>
//                   <input
//                     id="email"
//                     className={css.input}
//                     type="text"
//                     placeholder={
//                       props.role === "institute"
//                         ? (window.location.pathname.includes('/thalir-login')
//                           ? "Enter School Email"
//                           : "Enter Institute Email")
//                         : props.role === "regionem"
//                           ? "Enter Regional Mentor Email"
//                           : "Enter Chapter EM Email"
//                     }
//                     name={props.role === "institute" ? "instituteEmail" : "email"}
//                     value={
//                       props.role === "institute"
//                         ? props.instituteEmail
//                         : props.email
//                     }
//                     onChange={handleChange}
//                     maxLength={validation.authForm.userId.maxLen}
//                     autoComplete="on"
//                   />
//                 </div>
//               )}

//               <div className={css.inputGroup}>
//                 <label htmlFor="password" className={css.label} style={{ textAlign: 'left', display: 'block', width: '100%' }}>
//                   Password
//                 </label>
//                 <div style={{ position: "relative" }}>
//                   <input
//                     id="password"
//                     className={css.input}
//                     type={type}
//                     name="password"
//                     placeholder="Password"
//                     value={props.password}
//                     onChange={handleChange}
//                     maxLength={validation.authForm.password.maxLen}
//                     autoComplete="on"
//                   />
//                   <span
//                     className={css.passwordToggle}
//                     onClick={handleToggle}
//                     style={{
//                       position: "absolute",
//                       right: "10px",
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <Icon icon={icon} size={25} />
//                   </span>
//                 </div>
//               </div>

//               <Link
//                 onClick={handleForgotPassClick}
//                 className={css.forgotPassText}
//               >
//                 Forgot Password
//               </Link>
//               {loader && (
//                 <div className={css.forgotPassLoaderWrapper}>
//                   <div className={css.forgotPassLoader}>
//                     <Spinloader />
//                   </div>
//                 </div>
//               )}
//               <button
//                 className={css.btn}
//                 onClick={handleLogInClick}
//                 disabled={props.isBtnDisabled}
//               >
//                 {props.isBtnDisabled ? "Logging in..." : "Login"}
//               </button>
//               {props.role === "user" && (
//                 <>
//                   <p className={css.forgotPassText}>Don't have an account ?</p>
//                   <Link className={css.registerText} to="/user/register">
//                     Register
//                   </Link>
//                 </>
//               )}
//             </div>
//           )
//         }
//       </div >
//     </div >
//   );
// };


import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Spinloader from "./Spinloader";
import { useUserType } from "../../routes/common/UserTypeContext";
import { SERVER_ORIGIN, validation } from "../../utilities/constants";
import toast from "react-hot-toast";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";
import css from "../../css/common/login-form.module.css";

export const LoginForm = (props) => {
  const [modal, setModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);
  const { userType } = useUserType();
  const navigate = useNavigate();
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(eyeOff);

  const handleChange = (e) => props.onChange(e);
  const handleLogInClick = () => props.onClick();

  const handleToggle = () => {
    if (type === "password") {
      setIcon(eye);
      setType("text");
    } else {
      setIcon(eyeOff);
      setType("password");
    }
  };

  const handleForgotPassClick = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      setModalOpen(true);
    }, 600);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEmailSuccess(false);
    setPasswordResetSuccess(false);
    setRecoveryEmail("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleSubmitClick = async () => {
    setIsLoading(true);

    try {
      if (props.role === "regionem") {
        // regionem: direct reset
        if (!newPassword || !confirmPassword) {
          toast.error("Please fill in both password fields");
          setIsLoading(false);
          return;
        }

        if (newPassword !== confirmPassword) {
          toast.error("Passwords do not match");
          setIsLoading(false);
          return;
        }

        const response = await fetch(
          `${SERVER_ORIGIN}/api/${props.role}/auth/recover-pwd`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: recoveryEmail,
              newPassword,
              confirmPassword,
            }),
          }
        );

        const result = await response.json();
        setIsLoading(false);

        if (!response.ok) {
          toast.error(result.statusText || "Something went wrong");
          return;
        }

        toast.success("Password reset successfully!");
        setPasswordResetSuccess(true);

        const currentPath = window.location.pathname;
        let redirectPath = "/login";
        if (currentPath.includes("yuva-login")) redirectPath = "/yuva-login";
        if (currentPath.includes("thalir-login")) redirectPath = "/thalir-login";

        setTimeout(() => {
          handleModalClose();
          navigate(`${redirectPath}?userType=regionem`, { replace: true });
        }, 1000);
      } else {
        // Other users: email recovery
        const response = await fetch(
          `${SERVER_ORIGIN}/api/${props.role}/auth/recover-pwd`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: recoveryEmail }),
          }
        );

        const result = await response.json();
        setIsLoading(false);

        if (!response.ok) {
          toast.error(result.statusText || "Error sending recovery mail");
          return;
        }

        toast.success("Recovery mail sent successfully!");
        setEmailSuccess(true);
      }
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="loginWrapper">
      <div
        className={css.outerDiv}
        style={
          props.compact
            ? { width: "100%", maxWidth: "440px", margin: "0 auto" }
            : undefined
        }
      >
        {modal ? (
          <div className={css.loginModal}>
            {/* <p className={css.passHeading}>
              {props.role === "regionem" ? "Reset Password" : "Recover Password"}
            </p> */}
            {/* <p className={css.heading}>
              {(() => {
                const path = window.location.pathname.toLowerCase();
                const params = new URLSearchParams(window.location.search);
                const userType = params.get("userType");

                // ✅ Check Thalir/Yuva explicitly first
                if (path.includes("/thalir-login") && userType === "institute") {
                  return "School Login";
                }

                if (path.includes("/yuva-login") && userType === "institute") {
                  return "Institute Login";
                }

                // ✅ Handle other roles
                if (userType === "student" || userType === "user") {
                  return "Student Login";
                }
                if (userType === "regionem") {
                  return "Regional Mentor Login";
                }
                if (userType === "chapterem") {
                  return "Chapter EM Login";
                }
                if (userType === "admin") {
                  return "Admin Login";
                }

                // ✅ Fallback
                return "Login";
              })()}
            </p> */}

            <p className={css.heading}>
              {(() => {
                const path = window.location.pathname.toLowerCase();
                const params = new URLSearchParams(window.location.search);
                const userType = params.get("userType") || props.role;

                if (path.includes("/thalir-login") && userType === "institute") {
                  return "School Login";
                }

                if (path.includes("/yuva-login") && userType === "institute") {
                  return "Institute Login";
                }

                switch (userType) {
                  case "student":
                  case "user":
                    return "Student Login";
                  case "regionem":
                    return "Regional Mentor Login";
                  case "em":
                    return "Chapter EM Login";
                  case "admin":
                    return "Admin Login";
                  case "institute":
                    return "Institute Login";
                  default:
                    return "Login";
                }
              })()}
            </p>



            <input
              type="email"
              id="recoveryEmail"
              placeholder="Enter your email"
              autoComplete="on"
              className={css.forgotPassInput}
              value={recoveryEmail}
              style={{ marginBottom: "12px" }} // 👈 adds space below
              onChange={(e) => setRecoveryEmail(e.target.value)}
            />

            {props.role === "regionem" && (
              <>
                <input
                  type="password"
                  id="newPassword"
                  placeholder="New Password"
                  className={css.forgotPassInput}
                  value={newPassword}
                  style={{ marginBottom: "12px" }} // 👈 adds space below
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <input
                  type="password"
                  id="confirmPassword"
                  placeholder="Confirm New Password"
                  className={css.forgotPassInput}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </>
            )}

            {emailSuccess && (
              <p className={css.EmailSuccessText}>
                A mail has been sent to your e-mail address.
              </p>
            )}
            {passwordResetSuccess && (
              <p className={css.EmailSuccessText}>
                Password reset successfully! Redirecting...
              </p>
            )}

            <div className={css.forgotPassBtnWrapper}>
              <button
                className={css.forgotPassCancelBtn}
                onClick={handleModalClose}
              >
                Cancel
              </button>
              {!emailSuccess && !passwordResetSuccess && (
                <button
                  className={css.forgotPassBtn}
                  onClick={handleSubmitClick}
                  disabled={isLoading}
                >
                  {isLoading
                    ? "Processing..."
                    : props.role === "regionem"
                      ? "Reset Password"
                      : "Submit"}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div>
            {/* <p className={css.heading}>
              {props.role ? props.role.charAt(0).toUpperCase() + props.role.slice(1) : ""} Login
            </p> */}
              <p className={css.heading}>
              {(() => {
                const path = window.location.pathname.toLowerCase();
                const params = new URLSearchParams(window.location.search);
                const userType = params.get("userType") || props.role;

                if (path.includes("/thalir-login") && userType === "institute") {
                  return "School Login";
                }

                if (path.includes("/yuva-login") && userType === "institute") {
                  return "Institute Login";
                }

                switch (userType) {
                  case "student":
                  case "user":
                    return "Student Login";
                  case "regionem":
                    return "Regional Mentor Login";
                  case "em":
                    return "Chapter EM Login";
                  case "admin":
                    return "Admin Login";
                  case "institute":
                    return "Institute Login";
                  default:
                    return "Login";
                }
              })()}
            </p>

            {/* ID / Email field */}
            {props.role === "admin" || props.role === "user" ? (
              <input
                className={css.input}
                type="text"
                placeholder={
                  props.role === "user"
                    ? "Enter Student Username or Email"
                    : "Enter Admin ID"
                }
                name={props.role === "user" ? "userId" : "adminId"}
                value={props.role === "user" ? props.userId : props.adminId}
                onChange={handleChange}
                maxLength={validation.authForm.userId.maxLen}
                autoComplete="on"
              />
            ) : (
              <input
                className={css.input}
                type="text"
                placeholder={
                  props.role === "institute"
                    ? window.location.pathname.includes("/thalir-login")
                      ? "Enter School Email"
                      : "Enter Institute Email"
                    : props.role === "regionem"
                      ? "Enter Regional Mentor Email"
                      : "Enter Chapter EM Email"
                }
                name={props.role === "institute" ? "instituteEmail" : "email"}
                value={
                  props.role === "institute"
                    ? props.instituteEmail
                    : props.email
                }
                onChange={handleChange}
                maxLength={validation.authForm.userId.maxLen}
                autoComplete="on"
              />
            )}

            {/* Password */}
            <div style={{ position: "relative" }}>
              <input
                className={css.input}
                type={type}
                name="password"
                placeholder="Password"
                value={props.password}
                onChange={handleChange}
                maxLength={validation.authForm.password.maxLen}
                autoComplete="on"
              />
              <span
                className={css.passwordToggle}
                onClick={handleToggle}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <Icon icon={icon} size={25} />
              </span>
            </div>

            {/* Forgot password */}
            {/* <Link onClick={handleForgotPassClick} className={css.forgotPassText}>
              Forgot Password
            </Link> */}
            <span
              onClick={handleForgotPassClick}
              className={css.forgotPassText}
              style={{ cursor: "pointer" }}
            >
              Forgot Password
            </span>

            {loader && (
              <div className={css.forgotPassLoaderWrapper}>
                <div className={css.forgotPassLoader}>
                  <Spinloader />
                </div>
              </div>
            )}

            <button
              className={css.btn}
              onClick={handleLogInClick}
              disabled={props.isBtnDisabled}
            >
              {props.isBtnDisabled ? "Logging in..." : "Login"}
            </button>

            {props.role === "user" && (
              <>
                <p className={css.forgotPassText}>Don't have an account?</p>
                <Link className={css.registerText} to="/user/register">
                  Register
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

